export enum PricingOverrideActionTypes {
    QuoteLoaded = "QUOTE_LOADED",
    ResetPricingOverride = "RESET_PRICING_OVERRIDE",
    PricingOverrideSuccess = "PRICING_OVERRIDE_SUCCESS",
    PricingOverrideFailure = "PRICING_OVERRIDE_FAILURE",
    PricingMarkupChange = "PRICING_MARKUP_CHANGE",
  }